import { useEffect } from "react";
import { Control, UseFormSetValue } from "react-hook-form";
import { makeStyles } from "tss-react/mui";
import {
  MiControlledDatePicker,
  MiFileUpload,
  MiSection,
} from "@miplatform/components";
import { validInspectionFileTypes } from "@miplatform/constants";
import { IUploadedFile } from "@miplatform/types";
import { mdiCalendar, mdiCalendarOutline, mdiTag } from "@mdi/js";
import { Box } from "@mui/system";
import { InspectionSectionHeader } from "../InspectionSectionHeader";
import { IInspectionForm } from "../inspectionFormSchemas";
import { InspectionIssueForm } from "./IssueForm";
import { useRedTagDrawerViewModel } from "./useRedTagDrawerViewModel";

export const RedTagDrawer = ({
  control,
  onFileUploadChange,
  setValue,
}: {
  control: Control<IInspectionForm>;
  onFileUploadChange: (fileList: IUploadedFile[]) => void;
  setValue: UseFormSetValue<IInspectionForm>;
}) => {
  const { theme, classes } = useStyles();

  const { getTrades, trades } = useRedTagDrawerViewModel();

  useEffect(() => {
    getTrades();
  }, []);

  return (
    <Box>
      <MiSection
        headerTitle="Red Tag Inspection"
        headerIcon={mdiTag}
        headerIconColor={theme.palette.error.main}
      >
        <Box className={classes.formContainer}>
          <Box className={classes.dateInputs}>
            <InspectionSectionHeader
              title="Inspection Date/Time"
              icon={mdiCalendarOutline}
            />
            <Box className={classes.dateTimeInputContainer}>
              <Box className={classes.inputContainer}>
                <MiControlledDatePicker
                  label="Inspected Date"
                  name="inspectedDate"
                  control={control}
                  required
                  whiteBackground
                />
              </Box>
              <Box className={classes.inputContainer}>
                <MiControlledDatePicker
                  label="Reported Date"
                  name="reportedDate"
                  control={control}
                  required
                  whiteBackground
                />
              </Box>
            </Box>
          </Box>
          <MiFileUpload
            dragAndDrop
            showUploadButton
            title="Upload Files"
            onChange={onFileUploadChange}
            acceptFiles={validInspectionFileTypes.join(",")}
          />
        </Box>
        <Box>
          <InspectionSectionHeader title="Add Issues" icon={mdiCalendar} />
          <Box>
            <InspectionIssueForm
              control={control}
              trades={trades}
              setValue={setValue}
            />
          </Box>
        </Box>
      </MiSection>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
  },
  dateInputs: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  dateTimeInputContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  inputContainer: {
    flex: 1,
  },
}));
